/**
 * Sent with main-app login; must appear in the firm's allowed_ver on the server.
 * Bump when releasing a new client build.
 */
export const CLIENT_APP_VERSION = '2.0.0';
